<template lang="pug">
    div#rnd-mindcore-nyx-view
        mainHeader
        div.box
            div.has-text-centered
                strong.title Nyx
            hr

            div.columns
                div.column.is-6
                    img(:src="`${baseUrl}img/DSC_0081.jpg`")
                div.column.has-text-justified.give-padding
                    p Το Nyx είναι ένα πλήρως αυτοματοποιημένο  σύστημα περιπολίας και επίβλεψης χώρων με την χρήση drone.
                        | Το όνομά προέρχεται από την Ελληνική μυθολογία, συγκεκριμένα από την θεότητα Νυξ η οποία προσωποποιούσε την νύκτα.
                    p Σχεδιάζεται και υλοποιείται από την MindCore, συνδυάζοντας αρκετά από τα πεδία εξειδίκευσης της εταιρίας τόσο στο τομέα του λογισμικού όσο και του υλισμικού.  
                    br
                    p.underline.subtitle.has-text-weight-semibold Το σύστημα “NYX” και οι δυνατότητές του
                    ul.a
                        li Πλήρως αυτόνομες πτήσεις.
                        li Αυτόματη επαναφόρτιση μπαταριών.
                        li Απομακρυσμένος έλεγχος και αποστολή δεδομένων μέσω δικτύου.
                        li Έξυπνο σύστημα μηχανικής όρασης και διαχείρισης των δεδομένων της κάμερας. 
                        li Διακριτικός σχεδιασμός, για εξωτερική χρήση και προστασία από καιρικά φαινόμενα.
                        li Σύστημα αυτοδιάγνωσης και ελέγχου καλής λειτουργίας.
                        li Δυνατότητα λειτουργίας πάνω σε όχημα-κινητή μονάδα. 
            br
            br
            div.columns
                div.column
                    p.underline.subtitle.has-text-weight-semibold Το σύστημα αποτελείται από 3 βασικά μέρη:
                        //- ul.a
                            li Κλωβός Εδάφους (Ground Base)
                            li Σταθμός ελέγχου (Control Station)
                            li Ιπτάμενο μέρος (Drone)
                    br
                    
                    div.columns
                        div.column
                            div.card.has-equal-height
                                div.card-header
                                    div.card-header-title.is-centered Κλωβός Εδάφους (Ground Base)
                                div.card-content.has-text-justified
                                    ul.a
                                        li Σύστημα αυτοματοποιημένης φόρτισης των μπαταριών. 
                                        li Σύστημα τηλεμετρίας με το drone. 
                                        li Αυτόματος έλεγχος του χώρου με event από το σύστημα ασφάλειας ή/και με προκαθορισμένη περιπολία.
                                        li Επικοινωνία με τον σταθμό ελέγχου μέσω δικτύου τοπικά ή απομακρυσμένα.
                                        li Διακριτικός σχεδιασμός, αδιαβροχοποίηση και αντοχή σε καιρικά φαινόμενα. Κατάλληλο για εγκατάσταση σε εξωτερικό χώρο.
                                        li Ειδικός σχεδιασμός για λειτουργία πάνω σε όχημα.

                        div.column
                            div.card.has-equal-height
                                div.card-header
                                    div.card-header-title.is-centered Σταθμός Ελέγχου (Control Station)
                                div.card-content.has-text-justified
                                    ul.a
                                        li Έλεγχος του συστήματος, τοπικός ή απομακρυσμένος σε πραγματικό χρόνο.
                                        li Εξωτερικό χειριστήριο, για “μερικό” έλεγχο του συστήματος και της εξέλιξης της πτήσης.
                                        li Καταγραφή, αποθήκευση και διαχείριση των δεδομένων του συστήματος (data logging).
                                        li Αναφορά σφαλμάτων και βλαβών.
                                        li Ειδική έκδοση λογισμικού, για σταθμό εδάφους που επιχειρεί πάνω σε όχημα.

                        div.column
                            div.card.has-equal-height
                                div.card-header
                                    div.card-header-title.is-centered Ιπτάμενο μέρος (Drone)
                                div.card-content.has-text-justified
                                    ul.a
                                        li Πλήρως αυτόνομες πτήσεις. 
                                        li “Έξυπνο” σύστημα μηχανικής όρασης για απογείωση-προσγείωση ακριβείας.
                                        li Αυτοδιάγνωση και επιστροφή στο κλωβό εδάφους για αναγκαστική προσγείωση αν διαπιστωθεί σφάλμα.
                                        li Ακτίνα δράσης 2km και περιορισμός του χώρου κίνησης με γεωφράκτη.
                                        li Αποστολή τηλεμετρίας για εκτίμηση της κατάστασης του σκάφους εν-πτήση και στο έδαφος.

                    br
            div.columns
                div.column
                    p.underline.subtitle.has-text-weight-semibold Διάγραμμα ροής της λειτουργίας του συστήματος 
                        br
                        div.column
                            img(:src="`${baseUrl}img/flow_diagram.png`")
                        br
                        br
                        p.underline.subtitle.has-text-weight-semibold Πεδία εφαρμογών του συστήματος “NYX” 
                        div.column
                            img(:src="`${baseUrl}img/applications.jpg`")
                        br

            div.columns
                div.column.is-4
                div.column.has-text-justified
                    p.underline.subtitle.has-text-weight-semibold Προγραμματισμένες βελτιώσεις και μελλοντικοί στόχοι
                    ul.a
                        //- li Πλήρως αυτόνομες πτήσεις.
                        //- li Αυτόματη επαναφόρτιση μπαταριών.
                        //- li Απομακρυσμένος έλεγχος και αποστολή δεδομένων μέσω δικτύου.
                        li Έξυπνο σύστημα μηχανικής όρασης και διαχείρισης των δεδομένων της κάμερας. 
                        //- li Διακριτικός σχεδιασμός, για εξωτερική χρήση και προστασία από καιρικά φαινόμενα.
                        //- li Σύστημα αυτοδιάγνωσης και ελέγχου καλής λειτουργίας.
                        li Δυνατότητα λειτουργίας πάνω σε όχημα-κινητή μονάδα. 
            br
            br
                  
            //- div.columns
                div.column
                    div.column
                        p Το Nyx είναι ένα πλήρως αυτοματοποιημένο  σύστημα περιπολίας και επίβλεψης χώρων με την χρήση drone.
                        p Το όνομά προέρχεται από την Ελληνική μυθολογία, συγκεκριμένα από την θεότητα Νυξ η οποία προσωποποιούσε την νύκτα.
                        p Σχεδιάζεται και υλοποιείται από την MindCore, συνδυάζοντας αρκετά από τα πεδία εξειδίκευσης της εταιρίας τόσο στο τομέα του λογισμικού όσο και του υλισμικού.  
                    
                    div.column.is-6.is-offset-3    
                        img(:src="`${baseUrl}img/DSC_0081.jpg`")
                    br
                    p.underline.subtitle.has-text-weight-semibold Το σύστημα “NYX” και οι δυνατότητές του
                    br
                    br
                    ul.a
                        li Πλήρως αυτόνομες πτήσεις.
                        li Αυτόματη επαναφόρτιση μπαταριών.
                        li Απομακρυσμένος έλεγχος και αποστολή δεδομένων μέσω δικτύου.
                        li Έξυπνο σύστημα μηχανικής όρασης και διαχείρισης των δεδομένων της κάμερας. 
                        li Διακριτικός σχεδιασμός, για εξωτερική χρήση και προστασία από καιρικά φαινόμενα.
                        li Σύστημα αυτοδιάγνωσης και ελέγχου καλής λειτουργίας.
                        li Δυνατότητα λειτουργίας πάνω σε όχημα-κινητή μονάδα. 
                    br
                    p.underline.subtitle.has-text-weight-semibold Το σύστημα αποτελείται από 3 βασικά μέρη:
                        //- ul.a
                            li Κλωβός Εδάφους (Ground Base)
                            li Σταθμός ελέγχου (Control Station)
                            li Ιπτάμενο μέρος (Drone)
                    br
                    div.columns
                        div.column
                            div.card.has-equal-height
                                div.card-header
                                    div.card-header-title Κλωβός Εδάφους (Ground Base)
                                div.card-content
                                    ul.a
                                        li Σύστημα αυτοματοποιημένης φόρτισης των μπαταριών. 
                                        li Σύστημα τηλεμετρίας με το drone. 
                                        li Αυτόματος έλεγχος του χώρου με event από το σύστημα ασφάλειας ή/και με προκαθορισμένη περιπολία.
                                        li Επικοινωνία με τον σταθμό ελέγχου μέσω δικτύου τοπικά ή απομακρυσμένα.
                                        li Διακριτικός σχεδιασμός, αδιαβροχοποίηση και αντοχή σε καιρικά φαινόμενα. Κατάλληλο για εγκατάσταση σε εξωτερικό χώρο.
                                        li Ειδικός σχεδιασμός για λειτουργία πάνω σε όχημα.

                        div.column
                            div.card.has-equal-height
                                div.card-header
                                    div.card-header-title Σταθμός Ελέγχου (Control Station)
                                div.card-content
                                    ul.a
                                        li Έλεγχος του συστήματος, τοπικός ή απομακρυσμένος σε πραγματικό χρόνο.
                                        li Εξωτερικό χειριστήριο, για “μερικό” έλεγχο του συστήματος και της εξέλιξης της πτήσης.
                                        li Καταγραφή, αποθήκευση και διαχείριση των δεδομένων του συστήματος (data logging).
                                        li Αναφορά σφαλμάτων και βλαβών.
                                        li Ειδική έκδοση λογισμικού, για σταθμό εδάφους που επιχειρεί πάνω σε όχημα.

                        div.column
                            div.card.has-equal-height
                                div.card-header
                                    div.card-header-title Ιπτάμενο μέρος (Drone)
                                div.card-content
                                    ul.a
                                        li Πλήρως αυτόνομες πτήσεις. 
                                        li “Έξυπνο” σύστημα μηχανικής όρασης για απογείωση-προσγείωση ακριβείας.
                                        li Αυτοδιάγνωση και επιστροφή στο κλωβό εδάφους για αναγκαστική προσγείωση αν διαπιστωθεί σφάλμα.
                                        li Ακτίνα δράσης 2km και περιορισμός του χώρου κίνησης με γεωφράκτη.
                                        li Αποστολή τηλεμετρίας για εκτίμηση της κατάστασης του σκάφους εν-πτήση και στο έδαφος.

                    br
                    p.underline.subtitle.has-text-weight-semibold Διάγραμμα ροής της λειτουργίας του συστήματος 
                    br
                    div.column
                        img(:src="`${baseUrl}img/flow_diagram.png`")
                    br
                    p.underline.subtitle.has-text-weight-semibold Πεδία εφαρμογών του συστήματος “NYX” 
                    br
                    div.column
                        img(:src="`${baseUrl}img/applications.png`")
                    br
                    p.underline.subtitle.has-text-weight-semibold Προγραμματισμένες βελτιώσεις και μελλοντικοί στόχοι
                    ul.a
                        li Πλήρως αυτόνομες πτήσεις.
                        li Αυτόματη επαναφόρτιση μπαταριών.
                        li Απομακρυσμένος έλεγχος και αποστολή δεδομένων μέσω δικτύου.
                        li Έξυπνο σύστημα μηχανικής όρασης και διαχείρισης των δεδομένων της κάμερας. 
                        li Διακριτικός σχεδιασμός, για εξωτερική χρήση και προστασία από καιρικά φαινόμενα.
                        li Σύστημα αυτοδιάγνωσης και ελέγχου καλής λειτουργίας.
                        li Δυνατότητα λειτουργίας πάνω σε όχημα-κινητή μονάδα. 
                    
        Footer

</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'rnd-mindcore-nyx',
  components: {
    MainHeader,
    Footer
  },
  data: function () {
    return {
        baseUrl: process.env.BASE_URL,
    };
  }
}
</script>

<style scoped>
.underline {
    text-decoration-line: underline;
    text-decoration-skip-ink: none;
}

ul.a {
    list-style-type: disc;
    list-style-position: inside;
}

li {
    padding-bottom: 0.3rem;
}

.topic-card-title {
    padding: 0.5rem;
     /* text-align: center;  */
}

.has-equal-height {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.has-equal-height .card-footer {
  margin-top: auto;
}

.box {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;
}   

.give-padding {
    margin-left: 1.5rem;
}

</style>

